module.exports = {
    title: "Student Location",
    table: {
        country: "Country",
        city: "City",
    },
}
